"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadToS3 = void 0;
function urlToBlob(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onerror = reject;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                resolve(xhr.response);
            }
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    });
}
exports.uploadToS3 = (url, base64Img, xhr) => __awaiter(void 0, void 0, void 0, function* () {
    let body;
    if (xhr) {
        body = yield urlToBlob(base64Img);
    }
    else {
        const res = yield fetch(base64Img);
        body = yield res.blob();
    }
    return fetch(url, {
        method: "PUT",
        body
    });
});
//# sourceMappingURL=uploadToS3.js.map